



































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { ExamItem, ExamResult } from '@/app/exam/ui/exam-dashboard-types';
import { examsDashboardTableMixin } from '@/app/exam/ui/exams-dashboard-table-mixin';

@Component({
  mixins: [
    examsDashboardTableMixin
  ]
})
export default class DashboardExamResultsTableComponent extends Vue {
  @Prop()
  public examResults: ExamItem[];

  public examPassed(examResult: ExamResult): boolean {
    if (examResult.status === 'not-attempted') {
      return false;
    }

    return examResult.effectiveAttempt.result === 'passed';
  }

  public passedLabel(examResult: ExamResult) {
    return this.examPassed(examResult)
      ? this.$t('quiz.passed')
      : this.$t('quiz.failed');
  }

  public examAttempted(examResult: ExamResult): boolean {
    if (examResult.status === 'not-attempted') {
      return false;
    }     
    return true;
  }

  private withBracket(input: string) {
    if (!input) {
      return ''
    }
    return `(${input})`
  }
}
